import React from 'react';
import { Alert } from 'reactstrap';

export const MANAGED_IN_NEW_ADMIN_MESSAGE =
  'This record is managed in the new admin panel and cannot be changed here anymore.';

const NEW_ADMIN_PROD_HOSTS = [
  'admin.leadarena.com',
  'admin.ushamarketplace.com',
  'admin.leadtopia.com',
];

export const getNewAdminBaseUrl = (): string => {
  if (
    typeof window !== 'undefined' &&
    NEW_ADMIN_PROD_HOSTS.includes(window.location.hostname)
  ) {
    return 'https://admin.leadarena.app';
  }
  return 'https://stage-cb.leadarena.com';
};

export const getNewAdminPriceTierUrl = (priceTierID?: string): string =>
  `${getNewAdminBaseUrl()}/price-tiers/${priceTierID || ''}`;

export const getNewAdminLeadSourceUrl = (
  layerID?: string,
  vendorID?: string
): string =>
  `${getNewAdminBaseUrl()}/lead-sources/${
    layerID || ''
  }/edit?vendorId=${encodeURIComponent(vendorID || '')}`;

export const isManagedInNewAdmin = (
  record?: {
    cbNewAdmin?: boolean;
  } | null
): boolean => record?.cbNewAdmin === true;

const ManagedInNewAdminAlert: React.FC<{ href?: string }> = ({ href }) => (
  <Alert color="warning">
    {MANAGED_IN_NEW_ADMIN_MESSAGE}
    {href && (
      <>
        {' '}
        <a href={href} target="_blank" rel="noopener noreferrer">
          Open in new admin
        </a>
      </>
    )}
  </Alert>
);

export default ManagedInNewAdminAlert;
